export const endpoints = {
  PROFILE: '/v2/profile',
  CHALLENGE: '/v2/e-imzo/challenge',
  LOGIN: '/v2/auth/login',
  LOGOUT: '/v2/auth/logout',
  APPLICATIONS: '/v2/applications',
  APPLICATION_APPROVE: '/v2/applications/document/approve',
  APPLICATION_DOCUMENT_REJECT: '/v2/applications/document/reject',
  BANK_BRANCHES: '/v2/partners',
  INSURANCE_PRODUCTS: '/v2/partners/insurance',
  BANK_REGIONS: '/v2/regions',
  EMPLOYEES: '/v2/users',
  EMPLOYEES_DELETE_SELECTED: '/v2/users/delete-selected',
  EMPLOYEES_LOGIN_AS_USER: '/v2/auth/login-as-user',
  CREDIT_APPLICATIONS: '/v2/loans',
  PRODUCTS: '/v2/products',
  PRODUCTS_LIST: '/v2/products/list',
  LOAN_DOCUMENTS: '/v2/loans/documents',
  LOAN_DOCUMENT_TYPES_LIST: '/v2/loans/document-list',
  GET_PDF_FOR_SIGNING: '/v2/loans/documents/decoded',
  DOWNLOAD_PDF: '/v2/loans/documents/download',
  DECLINE_PDF: '/v2/loans/documents/decline',
  APPROVE_PDF: '/v2/loans/documents/sign',
  ROLES: '/v2/roles/list',
  DOWNLOAD_DOCUMENT: '/v2/loans/documents/download',
  MONITORING: '/v2/farmer-monitoring',
  MONITORING_REGIONS: '/v2/regions/regions',
  CREATE_POLICY: '/v2/loans/documents/create-policy',
  ATTACH_EMPLOYEE: '/v2/applications/attach-employee',
  DOCUMENT_UPLOAD: '/v2/applications/document/upload',
  APPLICATION_DOCUMENTS: '/v2/applications/document',
  APPLICATION_SEND_LAWYER: '/v2/applications/send-lawyer',
  WRITE_LAWYER_COMMENT: '/v2/applications/document/comment',
  WRITE_LAWYER_CONCLUSION: '/v2/applications/lawyer-conclusion',
  UNDERWRITER_CONCLUSION: '/v2/applications/underwriter-conclusion',
  UPDATE_OPTIONS: '/v2/applications/update-options',
  APPLICATION_REJECT: '/v2/applications/reject',
  FARMER_CRITERIA_INDEX: '/v2/farmer-criteria',
  FARMER_STATIC_DATA: '/v2/farmer-criteria/static-data',
  FARMER_CRITERIA_REPORT: '/v2/farmer-criteria/download-report',
};
